import React, { Component } from "react";
import { LocalStorageService, UserDocSuppService, UserService } from "../../../services";
import { SignatureBaseView, SignatureBaseDefinition, SignatureBaseUploadINE, SignatureBaseAutograph, SignatureBaseValidate } from "../../views";
import { ProfileValidator } from "../../../validators";
import { PDFView, InformationReliable } from "../../../assets/logos/icons";
import CredencialGris from "../../../assets/logos/icons/credencial_gris@2x.png";
import FirmaautografaGris from "../../../assets/logos/icons/firmaautografa_gris@2x.png";
import { useTranslation } from "react-i18next";

class SignatureBaseAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            selectedStep: 0,
            ineFrontImg: '',
            ineBackImg: '',
            signatureImg: '',
            nip: '',
            validateNip: '',
            nipCheck: false,
            firstName: '',
            firstLastName: '',
            secondLastName: '',
            fullName: '',
            signatureData: new FormData(),
            signatureBaseExist: false
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()
    userDocSuppService = new UserDocSuppService(this.url);
    userService = new UserService(this.url);
    validator = ProfileValidator(this.props.t);

    token = ''
    user = {}
    userInfo = {}

    async componentDidMount() {
        let messageError = 'Ocurrió un error al consultar la información del usuario'

        try {
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            this.user = this.localStorageService.getLocalStorageItem("user");
            this.userInfo = this.localStorageService.getLocalStorageItem('user')

            this.getUserData()
            this.getUserDocSupps()

            this.setState({
                token: this.token,
                user: this.user
            })
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }

    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequestingFalse = () => {
        this.setState({
            showErrorRequesting: false
        })
    }

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo);
                    }
                }
            }, time || 4000)
        })
    }

    stepMetadata = [
        { number: 0, component: SignatureBaseDefinition, handleBack: () => this.onBackStep(), handleNext: () => this.onNextStep() },
        { number: 1, component: SignatureBaseUploadINE, handleBack: () => this.onBackStep(), handleNext: () => this.validateUploadINE() },
        { number: 2, component: SignatureBaseAutograph, handleBack: () => this.onBackStep(), handleNext: () => this.validateNIPSignatureCheck() },
        { number: 3, component: SignatureBaseValidate, handleBack: () => this.onBackStep(), handleNext: () => this.handleFinish() },
    ]

    steps = [
        {
            icon: InformationReliable,
            title: this.props.t("requestReliableSignature.description"),
            next: this.props.t("requestReliableSignature.nextLaber"),
            back: this.props.t("button.cancel"),
        },
        {
            icon: CredencialGris,
            title: this.props.t("requestSignatureDetailView.enterYourIne"),
            next: this.props.t("requestReliableSignature.nextLaber"),
            back: this.props.t("button.return"),
        },
        {
            icon: FirmaautografaGris,
            title: this.props.t("requestSignatureDetailView.autographSignatureAndNIP"),
            next: this.props.t("requestReliableSignature.nextLaber"),
            back: this.props.t("button.return"),
        },
        {
            icon: PDFView,
            title: this.props.t("requestSignatureDetailView.resume"),
            next: this.props.t("signatureBaseValidate.validate"),
            back: this.props.t("button.return"),
        }
    ]

    onBackStep = () => {
        if (this.state.selectedStep === 0) {
            this.props.history.push('/profile')
        } else {
            this.setState({
                selectedStep: this.state.selectedStep - 1
            })
        }
        return window.scroll(0, 0)
    }

    onNextStep = () => {
        this.setState({
            selectedStep: this.state.selectedStep + 1,
        })
        return window.scroll(0, 0)
    }

    getUserData = async () => {
        let messageError = 'Ocurrió un error al consultar la información del usuario'
        try {
            let user = await this.userService.getUser(this.userInfo.userToken.sub, this.token)
            if (user) {
                let A3CloudData = user.userA3Cloud
                let firstName = A3CloudData.firstName
                let firstLastName = A3CloudData.firstLastName
                let secondLastName = A3CloudData.secondLastName
                let fullName = `${A3CloudData.firstName} ${A3CloudData.firstLastName} ${A3CloudData.secondLastName}`;


                this.setState({
                    firstName,
                    firstLastName,
                    secondLastName,
                    fullName
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    getUserDocSupps = async () => {
        this.toggleLoadingView(true)
        let messageError = 'Ocurrió un error al obtener las imágenes de la crendencial'
        try {
            let result = await this.userDocSuppService.getUserDocSupps(this.token);
            let signatureBaseExist = false
            if (result) {
                let { autographySignImg, ineFrontImg, ineBackImg } = result;
                if (autographySignImg, ineFrontImg, ineBackImg) {
                    signatureBaseExist = true
                }
                if (autographySignImg) {
                    this.setState({
                        signatureImg: "data:image/png;base64," + autographySignImg
                    });
                }

                if (ineFrontImg) {
                    this.setState({
                        ineFrontImg: "data:image/png;base64," + ineFrontImg
                    });
                }

                if (ineBackImg) {
                    this.setState({
                        ineBackImg: "data:image/png;base64," + ineBackImg
                    });
                }

                this.setState({
                    signatureBaseExist
                });
            }
            this.toggleLoadingView(false)
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    };

    setINEFront = (image) => {
        this.setState({
            ineFrontImg: image
        })
    }

    setINEBack = (image) => {
        this.setState({
            ineBackImg: image
        })
    }

    setIMGSignature = (imgSignature) => {
        this.setState({
            signatureImg: imgSignature
        })
    }

    setNIP = (nipValue) => {
        if (nipValue && this.state.nip.length >= 4 && nipValue.length >= 4) {
            return
        }

        this.setState({
            nip: nipValue
        })
    }

    setValidateNIP = (validateNIPValue) => {
        if (validateNIPValue && this.state.validateNip.length >= 4 && validateNIPValue.length >= 4) {
            return
        }

        this.setState({
            validateNip: validateNIPValue
        })
    }

    setNIPCheckbox = (e) => {
        let value = e.target.checked
        this.setState({
            nipCheck: value
        })
    }

    validateUploadINE = () => {
        let messageError = 'Ocurrió un error al cargar tu INE';

        if (!this.state.ineFrontImg) {
            messageError = 'Agregar la imagen frontal de tu INE'
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        if (!this.state.ineBackImg) {
            messageError = 'Agregar la imagen del reverso de tu INE'
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        this.onNextStep()

    }

    validateNIPSignatureCheck = () => {
        let messageError = this.props.t("requestReliableSignature.errors.general.nip");

        if (!this.state.signatureImg) {
            messageError = this.props.t("requestReliableSignature.errors.authograph")
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        if (!this.state.nip) {
            messageError = this.props.t("requestReliableSignature.errors.add.nip")
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        if (!this.state.validateNip) {
            messageError = this.props.t("requestReliableSignature.errors.add.confirmation.nip")
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        if (this.state.nip !== this.state.validateNip) {
            messageError = this.props.t("requestReliableSignature.errors.nips")
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        if (!this.state.nipCheck) {
            messageError = this.props.t("requestReliableSignature.errors.accept.terms")
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        this.onNextStep()
    }

    handleFinish = () => {
        this.toggleLoadingRequesting(true)
        if (this.state.signatureBaseExist) {
            this.changeUserDocSupps();
        } else {
            this.sendUserDocSupps();
        }
    }

    changeUserDocSupps = async () => {
        let messageError = this.props.t("signatureBaseAction.errors.identification");

        this.state.signatureData.delete("nipEnabled");
        this.state.signatureData.delete("nip");
        this.state.signatureData.append("nipEnabled", this.state.nipCheck)
        this.state.signatureData.append("nip", this.state.nip)

        try {
            let signtaureUpload = await this.userDocSuppService.changeUserDocSupps(this.token, this.state.signatureData);

            if (signtaureUpload && Number(signtaureUpload.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, true, '/')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {

            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    };

    sendUserDocSupps = async () => {
        let messageError = this.props.t("signatureBaseAction.errors.identification");

        this.state.signatureData.delete("nipEnabled");
        this.state.signatureData.delete("nip");
        this.state.signatureData.delete("fullName");
        this.state.signatureData.append("nipEnabled", this.state.nipCheck)
        this.state.signatureData.append("nip", this.state.nip)
        this.state.signatureData.append("fullName", this.state.fullName)

        try {
            let sigtaureCreated = await this.userDocSuppService.sendUserDocSupps(this.token, this.state.signatureData);
            if (sigtaureCreated && Number(sigtaureCreated.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, true, '/')
            } else if (sigtaureCreated && Number(sigtaureCreated.statusCode) === 460) {
                messageError = this.props.t("signatureBaseAction.errors.validate.identification")
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            } else if (sigtaureCreated && Number(sigtaureCreated.statusCode) === 462) {
                messageError = this.props.t("signatureBaseAction.errors.name.not.match")
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            } else if (sigtaureCreated && Number(sigtaureCreated.statusCode) === 463) {
                messageError = this.props.t("signatureBaseAction.errors.identification.expired")
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }else if(sigtaureCreated && Number(sigtaureCreated.statusCode) === 464){
                messageError = this.props.t("signatureBaseAction.errors.identification.not.recognized")
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }else{
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    };


    render() {
        return (
            <SignatureBaseView
                {...this.state}
                {...this.props}

                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequestingFalse={this.toggleErrorRequestingFalse}

                stepMetadata={this.stepMetadata}
                steps={this.steps}
                validator={this.validator}
                setINEFront={this.setINEFront}
                setINEBack={this.setINEBack}
                setIMGSignature={this.setIMGSignature}
                setNIP={this.setNIP}
                setValidateNIP={this.setValidateNIP}
                setNIPCheckbox={this.setNIPCheckbox}
                setAllSignatureData={this.setAllSignatureData}
            />
        )
    }
}

const SignatureBaseActionContainer = (props) => {
    let { t } = useTranslation()
    return (
        <SignatureBaseAction
            {...props}
            t={t}
        />
    )
}

export { SignatureBaseActionContainer as default }